var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7012 0C14.7017 0 9.90248 2.05573 6.37012 5.71137C2.83411 9.36846 0.847171 14.3282 0.846191 19.5C0.846191 24.6696 2.8348 29.633 6.37012 33.2886C9.90248 36.9443 14.7017 39 19.7012 39C24.7007 39 29.4999 36.9443 33.0323 33.2886C36.5676 29.633 38.5562 24.6696 38.5562 19.5C38.5562 14.3304 36.5676 9.36701 33.0323 5.71137C29.4999 2.05573 24.7007 0 19.7012 0Z",
    fill: "url(#paint0_linear_276_213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38102 19.2941C14.8784 16.8176 18.5434 15.1847 20.3758 14.3959C25.614 12.1434 26.7011 11.7521 27.4111 11.7389C27.5673 11.7363 27.9149 11.7762 28.1417 11.9659C28.3303 12.1258 28.3833 12.3422 28.4098 12.4941C28.4334 12.6458 28.4658 12.9916 28.4393 13.2616C28.1565 16.345 26.928 23.8275 26.3034 27.2811C26.0412 28.7424 25.5197 29.2324 25.0159 29.2802C23.92 29.3844 23.0892 28.5319 22.0286 27.8131C20.3699 26.6879 19.4331 25.9877 17.8216 24.89C15.9596 23.6212 17.1675 22.9238 18.2281 21.7843C18.5051 21.486 23.3308 16.9477 23.4221 16.536C23.4339 16.4845 23.4457 16.2926 23.3337 16.1914C23.2247 16.09 23.0627 16.1247 22.9448 16.1521C22.7769 16.1911 20.1284 18.0034 14.9904 21.5887C14.2391 22.1231 13.5586 22.3836 12.9458 22.3699C12.2741 22.355 10.9778 21.9762 10.0144 21.6527C8.83599 21.2556 7.89619 21.0457 7.97868 20.3714C8.01992 20.0204 8.48835 19.6612 9.38102 19.2941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_213",
    x1: 1886.35,
    y1: 0,
    x2: 1886.35,
    y2: 3900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.71,
    height: 39,
    fill: "white",
    transform: "translate(0.846191)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f4cf344a42956da736bd984f53c1cb7e.svg";
export { ForwardRef as ReactComponent };